import { makeAutoObservable } from "mobx";

import { StorageKey } from "@/shared/config";
import { storage } from "@/shared/lib";

export class ChatOnboardingStore {
  currentStep = 1;

  constructor() {
    makeAutoObservable(this);

    const savedStep = storage.getItem(StorageKey.OnboardingTooltipStep);
    if (savedStep) {
      this.currentStep = Number(savedStep);
    }
  }

  nextStep() {
    this.currentStep++;
    storage.setItem(StorageKey.OnboardingTooltipStep, this.currentStep);
  }
}
